import * as React from 'react';
import Translation from '../../UI/Translation';

const columns = [
  {
    title: <Translation id='STUDENT_STUDENTIMIE' />,
    dataIndex: 'firstName',
    key: 'firstName',
    type: 'text',
    sorter: false,
  },
  {
    title: <Translation id='STUDENT_STUDENTNAZWISKO' />,
    dataIndex: 'lastName',
    key: 'lastName',
    type: 'text',
    sorter: false,
  },
  {
    title: <Translation id='STUDENT_STUDENTALBUM' />,
    dataIndex: 'albumId',
    key: 'albumId',
    type: 'text',
    sorter: false,
    width: 100,
  },
  {
    title: <Translation id='STUDENT_OCENAKONCOWA' />,
    dataIndex: 'ocena',
    key: 'ocena',
    type: 'text',
    sorter: false,
    width: 100,
  },
  {
    title: <Translation id='STUDENT_PRZEDMIOTDATA' />,
    dataIndex: 'obligatoryjnaDataWystawienia',
    key: 'obligatoryjnaDataWystawienia',
    type: 'hour',
    sorter: false,
    width: 120,
  },
];

export default columns;
